import React from 'react';
import { Dialog, DialogContent, Button } from '@mui/material';

function ConfirmDeleteDialog({ open, onClose, handleDelete }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            BackdropProps={{
                sx: {
                    backgroundColor: 'var(--primary-popup-overlay-bg)',
                    backdropFilter: 'var(--primary-popup-overlay-blur)',
                },
            }}
            PaperProps={{
                style: {
                    backgroundColor: 'var(--primary-popup-background-color)',
                    border: '1px solid var(--primary-popup-stroke-color)',
                    borderRadius: '8px',
                    color: 'var(--primary-text-color)',
                    padding: '28px 24px',
                },
            }}
        >
            <DialogContent style={{ textAlign: 'center', padding: 0 }}>
                <h2
                    style={{
                        fontFamily: 'Poppins',
                        fontWeight: 400,
                        color: 'var(--primary-text-color)',
                        fontSize: '20px',
                        margin: '0 0 32px 0',
                    }}
                >
                    Are you sure you want to delete?
                </h2>
                <Button
                    onClick={handleDelete}
                    variant="outlined"
                    style={{
                        fontSize: '14px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        backgroundColor: 'var(--primary-popup-background-color)',
                        color: 'var(--primary-text-theme-color)',
                        textTransform: 'none',
                        border: '2px solid',
                        borderColor: 'var(--primary-text-theme-color)',
                        padding: '10px 28px',
                        minWidth: '150px',
                    }}
                >
                    Yes, Delete it
                </Button>
                <Button
                    onClick={onClose}
                    style={{
                        fontSize: '14px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        backgroundColor: 'var(--primary-button-background-color)',
                        color: 'var(--primary-button-text-color)',
                        textTransform: 'none',
                        padding: '10px 28px',
                        minWidth: '150px',
                        marginLeft: '20px',
                    }}
                >
                    No, keep it
                </Button>
            </DialogContent>
        </Dialog>
    );
}

export default ConfirmDeleteDialog;